import { axiosInstance, handleAxiosResponse } from "../../../core/sources/network";
import { getAppStoreCurrentState } from "../../../store";

import { showSuccess, handleError } from "../../app-messages";

export const declineInvitation = ({ invitationId }) => {
  return async (dispatch) => {
    try {
      const recruiterProfile = getAppStoreCurrentState().mainProfile;

      const response = await axiosInstance.delete(`/recruiters/${recruiterProfile.email}/invitations/${invitationId}`);

      const { message } = handleAxiosResponse(response);

      dispatch(showSuccess(message));

      return invitationId;
    } catch (error) {
      handleError(error?.response?.data?.message ?? error.message)(dispatch);
    }
  };
};
